import api from './api';

export const getApiConnectKeys = (page, params) => {
  return api.get('admin/ApiConnectKey', { params: { page: page, limit: 5, ...params } });
};

export const createApiConnectKey = (channelUid, key) => {
  return api.post('admin/api-connect-key', { channelUid, key });
};

export const revokeApiConnectKey = id => {
  return api.put(`admin/api-connect-key/${id}/revoke`);
};

export const removeApiConnectKey = id => {
  return api.delete(`admin/api-connect-key/${id}`);
};
